import { Box, Stack } from '@mui/material'
import { C1CopyText } from 'components/core/copytext/C1CopyText'
import { C1TextWithTruncation } from 'components/core/TextWithTruncation/C1TextWithTruncation'
import { FC } from 'react'

type BaseMetadataKeyValuePairProps = {
    metadataKey: React.ReactNode
    metadataValue: React.ReactNode
    fullWidth?: boolean
    noTruncation?: boolean
}

type CopyableProps = {
    isCopyable: true
    copyValue: string
}

type NonCopyableProps = {
    isCopyable?: false
    copyValue?: never
}

export type MetadataKeyValuePairProps = BaseMetadataKeyValuePairProps & (CopyableProps | NonCopyableProps)

export const MetadataKeyValuePair: FC<MetadataKeyValuePairProps> =
    ({ metadataKey, metadataValue, isCopyable = false, copyValue, fullWidth = false, noTruncation = false }) => {
        return (
            <Stack
                direction="row"
                alignItems="center"
                component="span"
                sx={{ width: fullWidth ? '100%' : 'auto' }}
            >
                <Box component="span" sx={{ fontWeight: '600', pr: 1, flexShrink: 0, '&:after': { content: '":"' } }}>
                    {metadataKey}
                </Box>
                <Box component="span" sx={{ minWidth: 0 }}>
                    {(isCopyable && copyValue)
                        ? <C1CopyText
                            value={metadataValue}
                            strValue={copyValue}
                            noTruncation={noTruncation}
                        />
                        : noTruncation
                            ? metadataValue
                            : <C1TextWithTruncation text={metadataValue} />}
                </Box>
            </Stack>
        )
    }
